import { ICommand } from 'core-ts-types';
export const markAsMetState: ng.ui.IState = {
  resolve: {
    setMarkAsMetSlot(setMarkAsMetSlotCommand: ICommand, $stateParams: ng.ui.IStateParamsService) {
      return setMarkAsMetSlotCommand($stateParams.genericSlot);
    }
  },
  data: {
    pageTitle: 'Mark as met'
  },
  params: {
    genericSlot: {}
  }
};

export const markAsUnMetState: ng.ui.IState = {
  resolve: {
    genericSlot: ($stateParams: ng.ui.IStateParamsService) => $stateParams.genericSlot
  },
  data: {
    pageTitle: 'Mark as unmet'
  },
  params: {
    genericSlot: {}
  }
};

const studentMarkAsUnMetStateState: ng.ui.IState = {
  ...markAsUnMetState,
  views: {
    'modal@my.planner.plan': {
      template: `<mark-as-unmet-dialog generic-slot="$resolve.genericSlot"></mark-as-unmet-dialog>`
    }
  }
};

const studentMarkAsMetStateState = {
  ...markAsMetState,
  views: {
    'modal@my.planner.plan': {
      template: `<mark-as-met-dialog></mark-as-met-dialog>`
    }
  }
};

export const ApMarkAsMetModelRoutes = {
  'my.planner.plan.mark_as_met': { ...studentMarkAsMetStateState },
  'my.planner.plan.default.mark_as_met': { ...studentMarkAsMetStateState },
  'my.planner.plan.coursegroup.mark_as_met': { ...studentMarkAsMetStateState },
  'my.planner.plan.mark_as_unmet': { ...studentMarkAsUnMetStateState },
  'my.planner.plan.default.mark_as_unmet': { ...studentMarkAsUnMetStateState },
  'my.planner.plan.coursegroup.mark_as_unmet': { ...studentMarkAsUnMetStateState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/mark_as_met_unmet_routes.ts